import { render, staticRenderFns } from "./SampleAnalysis.vue?vue&type=template&id=6604e1f4&"
import script from "./SampleAnalysis.vue?vue&type=script&lang=js&"
export * from "./SampleAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./SampleAnalysis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QVirtualScroll from 'quasar/src/components/virtual-scroll/QVirtualScroll.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QItem,QIcon,QMenu,QDate,QBtn,QTabs,QTab,QTooltip,QTabPanels,QTabPanel,QTable,QVirtualScroll});qInstall(component, 'directives', {ClosePopup});
